export const isTrackpad = (e: any) => {
  const deltaMode = e.deltaMode; // For some reason we have to do this, if we directly check e.deltaMode below firefox returns a different value

  if (e.wheelDeltaY) {
    if (e.wheelDeltaY === e.deltaY * -3) {
      return true;
    }
  } else if (deltaMode === 0) {
    return true;
  }
  return false;
};
